import { render, staticRenderFns } from "./NavigationItemBadge.vue?vue&type=template&id=de2583da&scoped=true"
import script from "./NavigationItemBadge.vue?vue&type=script&lang=js"
export * from "./NavigationItemBadge.vue?vue&type=script&lang=js"
import style0 from "./NavigationItemBadge.vue?vue&type=style&index=0&id=de2583da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2583da",
  null
  
)

export default component.exports